export const normalizeDecimalSeparator = (value: string) =>
  value.replace(/,/g, '.').trim();

export const parseNullableDecimal = (
  value: string | number | null | undefined
): number | null => {
  if (value === null || typeof value === 'undefined') {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const normalizedValue = normalizeDecimalSeparator(value);
  if (normalizedValue === '') {
    return null;
  }

  const numericValue = Number(normalizedValue);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const isValidDecimalInput = (
  value: string,
  options?: { allowNegative?: boolean }
) => {
  const pattern = options?.allowNegative
    ? /^-?(?:\d+(?:[.,]\d*)?|[.,]\d*)?$/
    : /^(?:\d+(?:[.,]\d*)?|[.,]\d*)?$/;

  return pattern.test(value.trim());
};
